// MyLifeStageCreate.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { GenerateThink5whysLifeStageCode } from '../../components/GenerateThink5whysCode';

const MyLifeStageCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [createSuccess, setCreateSuccess] = useState(false); 
  const [updateSuccess, setUpdateSuccess] = useState(false); 

  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [updateSuccessMsg, setUpdateSuccessMsg] = useState(''); 
 
  const [creatingLifeStage, setCreatingLifeStage] = useState(false); 
   
  const [verifyParentLifeStageSuccess, setVerifyParentLifeStageSuccess] = useState(false); 

  const [errors, setErrors] = useState({});
  
  const [parentLifeStageCreatorName, setParentLifeStageCreatorName] = useState(''); 
  const [autoLifeStageCode, setAutoTaskCode] = useState(GenerateThink5whysLifeStageCode());

  const userId = authState.user._id;
  const [formData, setFormData] = useState({
    createdBy: authState.user._id,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    lifestageCode: autoLifeStageCode, 
    lifestageTitle: '',
    myLifeStageRemarks: '',
    dateCreated: new Date(),
    isActive: 1,
    isDeleted: 0,
  });

  const [createClicked, setCreateClicked] = useState(false);

  const handleCreateClick = () => {
    if(formData.lifestageTitle==='')
      {
        errors.lifestageTitle="Title Must Not Be Blank";
        return;
      }
    setCreatingLifeStage(true);
    fetchLifeStageCreate();
  };

  const fetchLifeStageCreate = useCallback(() => {
    // console.log('userId:', userId);
  
    try {
      const config = {
        url: "/mylifestages",
        method: 'post',
        data: formData,
        headers: { Authorization: authState.token },
      };
  
      // console.log('Creating lifestage with config:', config);
  
      fetchData(config)
        .then(response => {
          if (response && response.status) {
            // console.log("LifeStage created successfully:", response);
            setCreateSuccess(true);
            setCreateSuccessMsg("LifeStage Created Successfully");
            errors.lifestageTitle='';
          } else {
            console.error("Failed to create profile:", response);
            setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
          }
        })
        .catch(error => {
          console.error("Error creating profile:", error);
          setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
        });
    } catch (error) {
      console.error('Error in fetchProfileCreate:', error);
      setCreateSuccessMsg("Sorry! Profile Not Created. Please retry.");
    }
  }, [userId, formData, authState, fetchData, setCreateSuccess, setCreateSuccessMsg]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchLifeStageCreate, setCreateSuccess, setCreateSuccessMsg]);


  const handleBackToMyLifestageListClick = () => {
    navigate('/myprofile-lifestages');
  };

  const handleUpdateClick = async () => {
    try {
      const response = await fetch(`/mylifestages/${formData._id}`, {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        // Update state or handle success as needed
        // console.log('LifeStage updated successfully.');
      } else {
        console.error('Failed to update lifestage:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating lifestage:', error.message);
    }
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - LifeStage Creation</h2>
      </div>
      <div className="m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white text-sm">
        <div className="flex flex-col justify-left mt-2">
          <div>
            <p className='text-sm text-yellow-200 mr-2'>Think5Whys LifeStage Code: {autoLifeStageCode} </p>
          </div>
          <div>
            <p className='text-sm text-white mb-1 mt-2'>Input LifeStage Title: </p>
          </div>          
          <div className='w-6/12 flex flex-row mt-2'>
            <input
              type="text"
              className="profile-input text-black"
              stage={{
                border: '1px solid #ccc',
                padding: '8px',
                width: '100%',
                boxSizing: 'border-box',
              }} 
              value={formData.lifestageTitle}
              onChange={(e) => setFormData({ ...formData, lifestageTitle: e.target.value })}
              placeholder="Enter lifestage title"
            />
          </div>
          <div className="flex flex-col">
            <label>LifeStage Description</label>
            <textarea
              className="profile-textarea"
              stage={{
                border: '1px solid #ccc',
                padding: '2px',
                backgroundColor: '#f0f0f0', 
                color: '#000000',
                maxWidth: '650px', 
                maxHeight: '150px' 
              }}
              value={formData.lifestageDesc}
              onChange={(e) => setFormData({ ...formData, lifestageDesc: e.target.value })}
              placeholder="Enter lifestage description"
            />
          </div>
          <div>
            <button
              className='bg-purple-700 mt-2'
              onClick={handleCreateClick}
              disabled={createSuccess}
              stage={{ maxWidth: '150px' }}
            >
              Create LifeStage
            </button>
            <br/>
            {errors.lifestageTitle !== '' && (
              <p className='text-red-500 text-lg'>{errors.lifestageTitle}</p>
            )}
          </div>
        </div>
        <div className="flex justify-center mt-4">
          <button
            className='bg-purple-700'
            onClick={handleUpdateClick}
            stage={{ maxWidth: '150px' }}
          >
            Update
          </button>
          <button
            className='bg-purple-700 ml-4'
            onClick={handleBackToMyLifestageListClick}
            stage={{ maxWidth: '250px' }}
          >
            Back To My LifeStage List
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default MyLifeStageCreate;
